import { Link } from "react-router-dom";
import bg1 from "../../assets/images/bg/bg-lines-one.png";
import { FiHome } from "../../assets/icons/vander";

export const AuthLayout = (props) => {
  return (
    <>
      <div className="back-to-home rounded d-none d-sm-block">
        <Link to="/" className="btn btn-icon btn-primary">
          <FiHome className="icons" />
        </Link>
      </div>
      <section
        className="bg-home d-flex bg-light align-items-center"
        style={{
          backgroundImage: `url(${bg1})`,
          backgroundPosition: "center",
        }}
      >
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-8 col-md-8">
              <div className="card login-page shadow my-4 rounded border-0">
                <div className="card-body">{props.children}</div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};
